import { CountToDirective } from './../directives/count-to.directive';
import { NgModule, ModuleWithProviders } from '@angular/core';
export class CountToModule {
/**
 * Use in AppModule
 * @return {?}
 */
public static forRoot(): ModuleWithProviders {
        return {
            ngModule: CountToModule,
            providers: []
        };
    }
/**
 * Use in features modules with lazy loading
 * @return {?}
 */
public static forChild(): ModuleWithProviders {
        return {
            ngModule: CountToModule,
            providers: []
        };
    }

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        CountToDirective
        // Pipes.
        // Directives.
    ],
    exports: [
        CountToDirective
        // Pipes.
        // Directives.
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CountToModule_tsickle_Closure_declarations() {
/** @type {?} */
CountToModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CountToModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
